import { Button } from 'antd';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

interface ViewInNewTabActionProps {
	to: string;
}

/**
 * Row action for picker contexts (work-order / walkthrough-task link modals): opens the work
 * order in a new tab so viewing it doesn't navigate away from the modal and lose the selection.
 */
const ViewInNewTabAction: FC<ViewInNewTabActionProps> = ({ to }) => (
	<div className={'ActionWrapper'}>
		<Link className={'ActionLink'} to={to} target="_blank" rel="noopener noreferrer">
			<Button className={'ActionButton'}>
				View <i className="icons8-font icons8-external-link ml-2" />
			</Button>
		</Link>
	</div>
);

export default ViewInNewTabAction;
